module.exports = __webpack_public_path__ + "img/foes-of-asgard.fd484166.svg";